import { ProducerType } from 'modules/pharmPermissions/pharmPermissionsForms/types/types';
import { CerberusIntegrationStatus } from 'components/CerberusIntegrationStatus';
import { CerberusIntegrationError } from 'components/CerberusIntegrationError';

type ProducerLocationsLabelProps = {
  producer: ProducerType;
};

export const ProducerLocationsLabel = ({ producer }: ProducerLocationsLabelProps) => (
  <>
    {producer.locationList?.map(
      ({
        id,
        activityLocationAddress,
        country,
        gmpComplianceConclusionNumber: gmpNumber,
        gmpComplianceConclusionDate: gmpDate,
      }) => {
        const label = [
          producer.address?.businessEntity?.name || producer.name,
          activityLocationAddress,
          country?.name,
          (gmpNumber || gmpDate) &&
            `заключение GMP (${[gmpNumber, gmpDate].filter(Boolean).join(', ')}`,
        ]
          .filter(Boolean)
          .join(', ');

        return (
          <div key={id}>
            <span>{label}</span>
            <CerberusIntegrationError showMessage={producer.incorrectCerberusLink} />
            <CerberusIntegrationStatus
              isEnteredManually={producer.enteredManually}
              isNotLinkedWithCerberus={producer.notLinkedWithCerberus}
            />
          </div>
        );
      }
    ) || null}
  </>
);
